import client from './apiclient.js';
import namespace from '../smartpak/smartpak';

const smartPakItem = {
    get: client.createConcatRequestMethod('get', '/api/smartPakItem/get/'),
    getByAccount: client.createConcatRequestMethod('get', '/api/smartPakItem/getByAccount/'),
    addSmartPakItem: client.createRequestMethod('post', '/api/smartPakItem/addSmartPakItem/'),
    saveSmartPakItem: client.createRequestMethod('put', '/api/smartPakItem/saveSmartPakItem/'),
    removeSmartPakItem: client.createRequestMethod('put', '/api/smartPakItem/removeSmartPakItem/')
};

namespace('api').smartPakItem = smartPakItem;

export default smartPakItem;
